
const signupValidation = [
    {
        type: "manual",
        name: "firstName",
        message: "Special character's and numbers are not allowed, please reenter your First Name."
    },
    {
        type: "manual",
        name: "lastName",
        message: "Special character's and numbers are not allowed, please reenter your Last Name."
    },
    {
        type: "manual",
        name: "email",
        message: "Please enter a valid email Id."
    },
    {
        type: "manual",
        name: "password",
        message: "Password should be minimum 8 alphanumeric characters"
    },
    {
        type: "manual",
        name: "carrierName",
        message: "Special character's and numbers are not allowed except for (&) ampersand sign, please reenter your My Company Name."
    }
];
const validStringPattern = /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F ]*$/;
// const emailPattern = /^[a-zA-Z0-9!#$%&'*+-/=?^_`{|}~.]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/
const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const numberPattern = /^.*[0-9].*/
const validCompanyName = /^[a-zA-Z& ]*$/;

export { signupValidation, validStringPattern, emailPattern, numberPattern, validCompanyName };